/* ==========================================================================
   Lumen — wishlist.js
   App-free wishlist backed by localStorage. Hearts carry the product data
   (handle/title/url/image/price) so the drawer renders with no server call.
   - [data-wishlist-toggle="handle"] (+ data-wishlist-* attrs) toggles an item
   - [data-wishlist-remove="handle"] removes one (used in the drawer)
   - [data-wishlist-count] header badge(s)
   - [data-wishlist-items] / [data-wishlist-empty] drawer mounts
   Dispatches document 'wishlist:updated' after every change.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'lumen:wishlist';
  var MAX = 100;

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) { /* quota / disabled */ }
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: list.length } }));
  }
  function has(handle) { return read().some(function (x) { return x && x.handle === handle; }); }
  function toggle(item) {
    if (!item || !item.handle) return false;
    var list = read();
    var i = -1;
    for (var k = 0; k < list.length; k++) { if (list[k] && list[k].handle === item.handle) { i = k; break; } }
    if (i > -1) list.splice(i, 1); else list.unshift(item);
    write(list);
    return i === -1; // true = added
  }
  function remove(handle) {
    write(read().filter(function (x) { return x && x.handle !== handle; }));
  }

  window.theme = window.theme || {};
  theme.wishlist = { read: read, has: has, toggle: toggle, remove: remove };

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = (s == null) ? '' : String(s);
    return d.innerHTML;
  }
  function itemFromButton(btn) {
    return {
      handle: btn.getAttribute('data-wishlist-toggle'),
      title: btn.getAttribute('data-wishlist-title') || '',
      url: btn.getAttribute('data-wishlist-url') || '',
      image: btn.getAttribute('data-wishlist-image') || '',
      price: btn.getAttribute('data-wishlist-price') || ''
    };
  }

  function syncButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = has(btn.getAttribute('data-wishlist-toggle'));
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
  function syncCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-count', n);
    });
  }

  function drawerLabels() {
    var d = document.querySelector('[data-wishlist-drawer]');
    return {
      view: (d && d.getAttribute('data-text-view')) || 'View',
      remove: (d && d.getAttribute('data-text-remove')) || 'Remove'
    };
  }
  function renderDrawer() {
    var mount = document.querySelector('[data-wishlist-items]');
    if (!mount) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var countEl = document.querySelector('[data-wishlist-drawer-count]');
    var list = read();
    if (countEl) countEl.textContent = list.length ? '(' + list.length + ')' : '';
    if (!list.length) {
      mount.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    var L = drawerLabels();
    mount.innerHTML = list.map(function (x) {
      var media = x.image
        ? '<img src="' + encodeURI(x.image) + '" alt="" loading="lazy" class="wishlist-drawer__img">'
        : '<span class="wishlist-drawer__img"></span>';
      return '<div class="wishlist-drawer__item">' +
        '<a href="' + encodeURI(x.url) + '" class="wishlist-drawer__item-media" data-dialog-close>' + media + '</a>' +
        '<div class="wishlist-drawer__item-info">' +
          '<a href="' + encodeURI(x.url) + '" class="wishlist-drawer__item-title" data-dialog-close>' + escapeHtml(x.title) + '</a>' +
          (x.price ? '<span class="wishlist-drawer__item-price">' + escapeHtml(x.price) + '</span>' : '') +
          '<div class="wishlist-drawer__item-actions">' +
            '<a href="' + encodeURI(x.url) + '" class="btn btn--secondary btn--sm" data-dialog-close>' + escapeHtml(L.view) + '</a>' +
            '<button type="button" class="wishlist-drawer__remove" data-wishlist-remove="' + escapeHtml(x.handle) + '">' + escapeHtml(L.remove) + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  /* toggle a heart */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var added = toggle(itemFromButton(btn));
    if (added) {
      btn.classList.add('wl-pop');
      setTimeout(function () { btn.classList.remove('wl-pop'); }, 450);
    }
    if (theme.toast) {
      theme.toast(added
        ? (btn.getAttribute('data-text-added') || 'Saved to wishlist')
        : (btn.getAttribute('data-text-removed') || 'Removed from wishlist'));
    }
  });

  /* remove from the drawer */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-wishlist-remove]');
    if (!rm) return;
    e.preventDefault();
    remove(rm.getAttribute('data-wishlist-remove'));
  });

  document.addEventListener('wishlist:updated', function () {
    syncButtons();
    syncCount();
    renderDrawer();
  });

  /* render fresh whenever the drawer opens */
  var drawer = document.getElementById('WishlistDrawer');
  if (drawer) drawer.addEventListener('dialog:open', renderDrawer);

  /* initial hydrate (deferred script → DOM already parsed) */
  syncButtons();
  syncCount();

  /* theme editor: re-hydrate on section re-render */
  document.addEventListener('shopify:section:load', function () { syncButtons(); syncCount(); });
})();
